import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PlantillaMemo } from '../../../../models/PlantillaMemo';
import { PlantillasMemosService } from '../../../../services/plantillas-memos.service';
import { AppTitleService } from '../../../../services/app-title.service';
import { MatDialog } from '@angular/material/dialog';
import { DlgAddPlantillaMemoComponent } from '../../../../commons/dlg-add-plantilla-memo/dlg-add-plantilla-memo.component';
import { DlgUpdatePlantillaMemoComponent } from '../../../../commons/dlg-update-plantilla-memo/dlg-update-plantilla-memo.component';
import { MatToolbarModule } from "@angular/material/toolbar";

@Component({
    selector: 'app-plantillas-memos',
    imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule
],
    templateUrl: './plantillas-memos.component.html',
    styleUrl: './plantillas-memos.component.scss'
})
export class PlantillasMemosComponent implements OnInit {
  plantillasMemos: PlantillaMemo[] = []

  displayedColumns: string[] = ["nomPlantilla", 'descripcion', 'definicCampo','actions'];
  dataSource = new MatTableDataSource<PlantillaMemo>([])

  constructor(
    private plantillasMemosService: PlantillasMemosService,
    public dlg: MatDialog,
  ) {
    inject(AppTitleService).setTitle("Administraci\xf3n");
  }

  ngOnInit(): void {
    this.fetchPlantillasMemos()
  }

  onAddPlantillaMemo() {
    const dialogRef = this.dlg.open(DlgAddPlantillaMemoComponent, {
      maxWidth: "50vw",
      width: "500px",
    })
    dialogRef.afterClosed().subscribe((result: PlantillaMemo | null) => {
      if (result) {
        this.fetchPlantillasMemos()
      }
    });
  }

  onUpdatePlantillaMemo(plantillaMemo: PlantillaMemo) {
    const dialogRef = this.dlg.open(DlgUpdatePlantillaMemoComponent, {
      maxWidth: "50vw",
      width: "500px",
      data: plantillaMemo
    })
    dialogRef.afterClosed().subscribe((result: PlantillaMemo | null) => {
      if (result) {
        this.fetchPlantillasMemos()
      }
    });
  }

  fetchPlantillasMemos() {
    this.plantillasMemosService.listConfigurationParameters().subscribe({
      next: (response) => {
        this.plantillasMemos = response
        this.dataSource!.data = this.plantillasMemos
      }
    })
  }
}
